import { del, get, patch, post } from "src/services/api";

const fetchValueReferenceDefaults = async ({ signal } = {}) =>
  await get({ endpoint: "metrics/value-references/defaults", signal });

const fetchValueReferenceOverrides = async (assistantId) =>
  await get({
    endpoint: "metrics/value-references/overrides",
    params: { assistantId }
  });

const createValueReferenceOverride = async (data) =>
  await post({ endpoint: "metrics/value-references/overrides", data });

const updateValueReferenceOverride = async (data) =>
  await patch({ endpoint: "metrics/value-references/overrides", data });

const deleteValueReferenceOverride = async (data) =>
  await del({ endpoint: "metrics/value-references/overrides", data });

export default {
  fetchValueReferenceDefaults,
  fetchValueReferenceOverrides,
  createValueReferenceOverride,
  updateValueReferenceOverride,
  deleteValueReferenceOverride
};
